<span>
  <label *ngIf="props.altLabel" [for]="field.id">{{ props.altLabel }}</label>
  <p-chips
    class="{{ !!formControl.value ? 'p-inputwrapper-filled' : '' }}"
    [formControl]="formControl"
    [formlyAttributes]="field"
    [placeholder]="props.placeholder"
    [style]="props.style"
    [styleClass]="props.styleClass"
    [max]="props.max"
    [maxlength]="props.maxlength"
    [inputStyle]="props.inputStyle"
    [inputStyleClass]="props.inputStyleClass"
    [id]="field.id"
    (onAdd)="props.onAdd && props.onAdd(field, $event)"
    (onRemove)="props.onRemove && props.onRemove(field, $event)"
    (onFocus)="props.onFocus && props.onFocus(field, $event)"
    (onBlur)="props.onBlur && props.onBlur(field, $event)"
    (onChipClick)="props.onChipClick && props.onChipClick(field, $event)"
  ></p-chips>
</span>
